import React, { forwardRef } from "react";
import { Map, TileLayer, withLeaflet } from "react-leaflet";
import { useSelector } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { MEASUREOPTIONS } from "~/utils";
import { useCitra } from "~/hooks/useCitra";
import HomeControl from "./HomeControl";
import Direction from "./RouteMachine";
import MeasureControlDefault from "~/components/MeasureControl";
import LeafletBrowserPrint from "./LeafletBrowserPrint";

const mapStyles = {
  width: "calc(100%)",
  height: "100vh",
};

const MeasureControl = withLeaflet(MeasureControlDefault);

const MapsCore = forwardRef(
  (
    {
      children,
      download,
      handleDownloadPeta,
      editStyleLayers,
      handleEditStyleLayers,
      handleHomeCallback,
      dynamicDownloadMaps,
      ...rest
    },
    ref
  ) => {
    const { desa } = useSelector((state) => state.Auth);
    const { directionToggle, basemap, citra } = useSelector(
      (state) => state.Map
    );

    const citraURL = useCitra();

    if (desa?.center && desa?.zoom) {
      return (
        <Map
          ref={ref}
          center={desa?.center}
          zoom={desa?.zoom}
          zoomControl={false}
          maxZoom={20}
          style={mapStyles}
          {...rest}
        >
          {children}

          {basemap === "googlemap" ? (
            <TileLayer
              url={"https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"}
              subdomains={["mt0", "mt1", "mt2", "mt3"]}
            />
          ) : (
            <TileLayer
              url={"https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"}
              subdomains={["mt0", "mt1", "mt2", "mt3"]}
            />
          )}

          {citra && <TileLayer url={citraURL} />}

          {directionToggle && (
            <Direction ref={ref} from={desa?.center} to={desa?.center} />
          )}

          <HomeControl
            ref={ref}
            position="topright"
            download={download}
            editStyleLayers={editStyleLayers}
            dynamicDownloadMaps={dynamicDownloadMaps}
            handleEditStyleLayers={handleEditStyleLayers}
          />
          <MeasureControl {...MEASUREOPTIONS} />
          <LeafletBrowserPrint position="topright" ref={ref} />
        </Map>
      );
    }

    return (
      <Modal isOpen centered>
        <ModalHeader>Centroid Desa Tidak Ditemukan !</ModalHeader>

        <ModalBody>Silakan tambahkan centroid desa di Profil Desa</ModalBody>

        <ModalFooter>
          <Link className="btn btn-primary" to="/user/profil/profil-desa/">
            Ke Profil Desa
          </Link>
        </ModalFooter>
      </Modal>
    );
  }
);

export default MapsCore;

MapsCore.propTypes = {
  children: PropTypes.node,
  download: PropTypes.bool,
  editStyleLayers: PropTypes.bool,
  handleDownloadPeta: PropTypes.func,
  handleHomeCallback: PropTypes.func,
  handleEditStyleLayers: PropTypes.func,
  dynamicDownloadMaps: PropTypes.bool,
};
